/**
 * @module app.shared
 */

import { encodeQueryString } from 'app/shared/lib/utilities';

export class ApiAction {

    // TODO: switch back to internals
    // INCOMPLETE: switch back to internals
    public body: Object | null = null;

    private readonly name: string | null = null;
    private url: string | null = null;
    private tenant: string | null = null;
    private disposition: string | null = null;
    private reason: string | null = null;
    private language: string | null = null;
    private applicationEventCode: string | null = null;

    constructor(name: string | null, url: string, body: Object) {
        this.name = name;
        this.url = url;
        this.body = body;
    }

    public hasTenant(): boolean {
        return !!this.tenant;
    }

    public withTenant(tenant: string | null): this {
        this.tenant = tenant;
        return this;
    }

    public withReason(reason: string | null): this {
        this.reason = reason;
        return this;
    }

    public withLanguage(lang: string | null): this {
        this.language = lang;
        return this;
    }

    public withApplicationEventCode(aec: string | null): this {
        this.applicationEventCode = aec;
        return this;
    }

    public overrideUrl(url: string): this {
        this.url = url;
        return this;
    }

    public usingDisposition(value: string): this {
        if(value) {
            this.disposition = value;
        }
        return this;
    }

    public toString(): string {
        if(!this.url) {
            return '';
        }

        const slash = this.url.endsWith('/') ? '' : '/';
        const actionCode = this.name ? `!${this.name}` : '';
        const url = this.tenant ? `${encodeURI(this.tenant)}/${this.url}${slash}${actionCode}` : this.url;
        const query: string[] = [];

        if(this.disposition) {
            query.push(`disposition=${encodeQueryString(this.disposition)}`);
        }
        if(this.reason) {
            query.push(`reason=${encodeQueryString(this.reason)}`);
        }
        if(this.language) {
            query.push(`lang=${encodeQueryString(this.language)}`);
        }
        if(this.applicationEventCode) {
            query.push(`aec=${encodeQueryString(this.applicationEventCode)}`);
        }

        return query.length > 0 ? `${url}?${query.join('&')}` : url;
    }

}
